export const edkInfo = {
  version: '23.08.07.01'
}
